import _ from 'lodash';
import filters from '../core/filters';

import infoBoard from '../core/infoboard';
import worldMap from '../core/map';
import translate from '../core/tools/translate';
import environment from '../environment';
import { CoreControl } from './CoreControl';
import { VectorType } from './VectorType';
import api from '../api';
import { ContextEnum } from '../../enuns/context.enum';
import { NETWORK_ICON, getNetworkSymbology } from '../layers/GreenfieldLayer';

const LayerInfo = (name) => require('../info').get(name);

export class GreenfieldControl extends CoreControl {
    constructor () {
        super({ name: 'Greenfield' });

        this._filterCallback = this._filterCallback.bind(this);
        this._toggleLabel = this._toggleLabel.bind(this);
        this.createFilter = this.createFilter.bind(this);
        this.resizeIcon = this.resizeIcon.bind(this);
        this.selectGreenField = this.selectGreenField.bind(this);
        this._change = this._change.bind(this);
        this.highlight = this.highlight.bind(this);
        this.unselect = this.unselect.bind(this);
        this.select = this.select.bind(this);
    }

    static getInstance () {
        if (!GreenfieldControl._instance) {
            GreenfieldControl._instance = new GreenfieldControl();
        }

        return GreenfieldControl._instance;
    }

    selectGreenField (value, text) {
        if (_.isString(value)) {
            value = Number(value);
        }

        this.getLayer().options.remote.params.greenFieldType = value;

        if (this.check() && this.getLayer().visible()) {
            api.general.log.action(ContextEnum.LayerGreenfield, 'Update Filter Greenfield Type', JSON.stringify({ GreenfieldType: text }));
            this.getLayer().redraw();
        }
    }

    init () {
        this._tags = {
            tagName: {
                property: 'Name',
                align: 'east',
                size: 9,
                bold: true,
                box: true
            },
            tagAreaName: {
                property: 'Nome',
                box: true,
                colorize: true,
                color: '#fff59d',
                bold: true,
                size: 9,
                offsetY: 60
            },
            tagAction: {
                property: 'Action',
                align: 'east',
                offsetY: 20,
                size: 9,
                colorize: true,
                color: '#80cbc4',
                bold: true,
                box: true
            },
            tagPriorityHigh: {
                property: 'Priorityhigh',
                align: 'east',
                offsetY: -20,
                size: 9,
                colorize: true,
                color: '#00917C',
                bold: true,
                box: true
            },
            tagPriorityMedium: {
                property: 'Prioritymedium',
                align: 'east',
                offsetY: -20,
                size: 9,
                colorize: true,
                color: '#FF9B50',
                bold: true,
                box: true
            },
            tagPriorityLow: {
                property: 'Prioritylow',
                align: 'east',
                offsetY: -20,
                size: 9,
                colorize: true,
                color: '#C70039',
                bold: true,
                box: true
            },
            tagPriorityVeryLow: {
                property: 'Priorityverylow',
                align: 'east',
                offsetY: -20,
                size: 9,
                colorize: true,
                color: '#6B0B28',
                bold: true,
                box: true
            }
        };

        const values = {
            disableSlider: true,
            help: translate(`Help.${this.options.name}`),
            id: 'layer-greenfield',
            input: 'checkbox',
            label: translate(`Common.${this.options.name}`),
            layer: this.getLayer,
            change: this._change,
            name: this.options.name,
            type: 'vector-points',
            filter: {
                enable: true,
                click: this.createFilter
            },
            purge: this.purge,
            tab () {
                return $('#greenfield-tab-link');
            },
            resize: {
                name: `pinSize${this.options.name}`,
                change: this.resizeIcon,
                type: 'radio'
            },
            dropdown: [],
            checkbox: this._getCheckboxOptions(),
            links: {}
        };

        if (environment.get('CONFIG.FILTERS.GREENFIELD_TYPES').length > 1) {
            values.dropdown.push({
                name: 'list',
                dataSource: _.map(environment.get('CONFIG.FILTERS.GREENFIELD_TYPES'), t => {
                        if (environment.get('CONFIG.CLIENT').toLowerCase() == "gm") {
                            switch (t.id) {
                                case 1: return ({ text: "GM", value: t.id });
                                case 2: return ({ text: "GMica", value: t.id });
                                default: return ({ text: "GM", value: t.id });
                            }
                        }

                        return ({ text: t.name, value: t.id });
                    }
                ),
                change: this.selectGreenField
            });
        }

        if (!this._instance) {
            this._instance = new VectorType(values);
        }
    }

    _change (e) {
        try {
            api.general.log.action(environment._getContextEnum(this.options.name), e.checked ? 'enable' : 'disable');
            const layer = this.getLayer();

            if (e.checked) {
                layer.redraw();
            } else {
                layer.hide();
            }
        } catch (err) {
            console.log('ERROR: ', err);
        }
    }

    createFilter () {
        return filters.create({
            id: `filter-greenfield`,
            label: translate(`Common.Greenfield`),
            type: 'greenfield',
            direction: 'up',
            onSubmit: this._filterCallback
        });
    }

    _getCheckboxOptions () {
        const contents = [
            { name: 'tagName', label: translate('Action.ShowTagPointName') },
            { name: 'tagAreaName', label: translate('Action.ShowTagAreaName') },
            { name: 'tagAction', label: translate('Action.ShowTagAction') },
            { name: 'tagPriority', label: translate('Action.ShowTagPriority') }
        ];

        const res = {};
        contents.forEach(content => {
            res[content.label] = {
                name: content.name,
                change: isChecked => {
                    this._toggleLabel(isChecked, content.name);
                },
                style: {
                    change: tag => {
                        this._tags[content.name] = tag;
                        this._toggleLabel();
                    },
                    options: this._tags[content.name]
                }
            };
        });

        return res;
    }

    _getLayerTag () {
        if (!this.getControls().checkbox) { return undefined; }

        const tags = [];

        if ((this.getControls().checkbox.tagName || {}).status) {
            tags.push(_.assign({}, this._tags.tagName));
        }

        if ((this.getControls().checkbox.tagAction || {}).status) {
            tags.push(_.assign({}, this._tags.tagAction));
        }

        if ((this.getControls().checkbox.tagPriority || {}).status) {
            tags.push(_.assign({}, this._tags.tagPriorityHigh));
            tags.push(_.assign({}, this._tags.tagPriorityMedium));
            tags.push(_.assign({}, this._tags.tagPriorityLow));
            tags.push(_.assign({}, this._tags.tagPriorityVeryLow));
        }

        return tags.length === 1 ? tags[0] : tags;
    }

    _getLayerAreaTag () {
        if (!this.getControls().checkbox) { return undefined; }

        const { tagAreaName } = this.getControls().checkbox;
        const tags = [];

        if ((tagAreaName || {}).status) {
            tags.push(_.assign({}, this._tags.tagAreaName));
        }

        tags.forEach(tag => {

        });

        return tags.length === 1 ? tags[0] : tags;
    }

    _setLabel () {
        this.getLayer().setOptions({ tag: this._getLayerTag() });
        this.getLayer(worldMap.getCurrent(), 'GreenfieldArea').setOptions({ tag: this._getLayerAreaTag() });
    }

    _toggleLabel (isChecked, name) {
        api.general.log.action(ContextEnum.LayerGreenfield, `${isChecked ? 'Show' : 'Hide'} ${name}`);
        this._setLabel();
        if (this.getLayer().visible()) {
            this.getLayer().reload();
            this.getLayer(worldMap.getCurrent(), 'GreenfieldArea').reload();
        }
    }

    _filterCallback (values) {
        const layerFilers = {
            IdType: values.IdType ? (_.isArray(values.IdType.value) && _.size(values.IdType.value)) ? values.IdType.value : [] : []
        };

        const filter = this.getLayerFilters();

        _.forEach(layerFilers, (val, key) => {
            if (_.size(val) || (_.isBoolean(val))) {
                filter.properties[key] = val;
            } else {
                delete filter.properties[key];
            }
        });

        this.setLayerFilters(filter);
        api.general.log.action(ContextEnum.LayerGreenfield, 'Filtro', JSON.stringify(filter));

        if (!this.check()) {
            this.check(true);
        }
    }

    getLayerFilters() {
        const filter = (this.getLayer().options.filter || {});

        if (!filter.properties) filter.properties = {};

        return filter;
    }

    setLayerFilters (filter) {
        this.getLayer().setOptions({ filter });

        if (this.check() && this.getLayer().visible()) {
            this.getLayer().reload();
        }
    }

    toggleVisibility (id, layer) {
        return this._instance.toggleVisibility(id, layer);
    }

    highlight (marker, event) {
        return this._instance.highlight(marker, event);
    }

    select(marker, type) {
        this._instance.select(marker, type);
    }

    unselect(marker, type) {
        this._instance.unselect(marker, type);
    }

    view (values) {
        return LayerInfo(this.options.name).create(values);
    }

    show (options = {}, features = this.getLayer().getCurrentFeatures()) {
        if ($('#greenfield-collapse').length === 0 || options.refresh) {
            if (options.empty) {
                this.view(null);
            } else {
                this.view(features);
            }
        }

        if (options.show) {
            infoBoard.open();
            $('#greenfield-tab-link').trigger('click');
            if (options.id) {
                const title = $(`#${this.options.name.toLocaleLowerCase()}-title-${options.id}`);
                return setTimeout(() => {
                    if (title[0] && !title[0].isOpen) {
                        title.trigger('select');
                    }

                    if (options.tab === 'summary') {
                        return $(`#button-${this.options.name.toLocaleLowerCase()}-summary-${options.id}`).trigger('click');
                    }
                }, 100);
            }
        }
    }

    resizeIcon (value) {
        const { symbology } = this.getLayer().options;
        switch (value) {
        case 'large':
            symbology.values = [{
                value: 'circle',
                style: {
                    icon: {
                        fields: ['TierColor'],
                        iconUrl: `${environment.get('IMAGES_HOST')}/pin_circle_{TierColor}.png`,
                        iconSize: [29, 29], // size of the icon
                        iconAnchor: [15, 15], // point of the icon which will correspond to marker's location
                        labelAnchor: [15, -5]
                    },
                    riseOnHover: true
                }
            }, {
                value: 'triangle',
                style: {
                    icon: {
                        fields: ['TierColor'],
                        iconUrl: `${environment.get('IMAGES_HOST')}/pin_triangle_{TierColor}.png`,
                        iconSize: [29, 29], // size of the icon
                        iconAnchor: [15, 15], // point of the icon which will correspond to marker's location
                        labelAnchor: [15, -5]
                    },
                    riseOnHover: true
                }
            }, {
                value: 'pi',
                style: {
                    icon: {
                        fields: ['TierColor'],
                        iconUrl: `${environment.get('IMAGES_HOST')}/pin_pi_{TierColor}.png`,
                        iconSize: [50, 64], // size of the icon
                        iconAnchor: [25, 60], // point of the icon which will correspond to marker's location
                        labelAnchor: [25, -32]
                    },
                    riseOnHover: true
                }
            }, {
                value: 'pi_2',
                style: {
                    icon: {
                        fields: ['TierColor'],
                        iconUrl: `${environment.get('IMAGES_HOST')}/pin_pi_2_{TierColor}.png`,
                        iconSize: [50, 64], // size of the icon
                        iconAnchor: [25, 60], // point of the icon which will correspond to marker's location
                        labelAnchor: [25, -32]
                    },
                    riseOnHover: true
                }
            }];
            break;

        case 'medium':
            symbology.values = [{
                value: 'circle',
                style: {
                    icon: {
                        fields: ['TierColor'],
                        iconUrl: `${environment.get('IMAGES_HOST')}/pin_circle_{TierColor}_sm.png`,
                        iconSize: [21, 21], // size of the icon
                        iconAnchor: [10, 10], // point of the icon which will correspond to marker's location
                        labelAnchor: [10, -3]
                    },
                    riseOnHover: true
                }
            }, {
                value: 'triangle',
                style: {
                    icon: {
                        fields: ['TierColor'],
                        iconUrl: `${environment.get('IMAGES_HOST')}/pin_triangle_{TierColor}_sm.png`,
                        iconSize: [21, 18], // size of the icon
                        iconAnchor: [10, 9], // point of the icon which will correspond to marker's location
                        labelAnchor: [10, -3]
                    },
                    riseOnHover: true
                }
            }, {
                value: 'pi',
                style: {
                    icon: {
                        fields: ['TierColor'],
                        iconUrl: `${environment.get('IMAGES_HOST')}/pin_pi_{TierColor}_sm.png`,
                        iconSize: [35, 45], // size of the icon
                        iconAnchor: [18, 45], // point of the icon which will correspond to marker's location
                        labelAnchor: [18, -24]
                    },
                    riseOnHover: true
                }
            }, {
                value: 'pi_2',
                style: {
                    icon: {
                        fields: ['TierColor'],
                        iconUrl: `${environment.get('IMAGES_HOST')}/pin_pi_2_{TierColor}_sm.png`,
                        iconSize: [35, 45], // size of the icon
                        iconAnchor: [18, 45], // point of the icon which will correspond to marker's location
                        labelAnchor: [18, -24]
                    },
                    riseOnHover: true
                }
            }];
            break;

        case 'small':
            symbology.values = [{
                value: 'circle',
                style: {
                    icon: {
                        fields: ['TierColor'],
                        iconUrl: `${environment.get('IMAGES_HOST')}/pin_circle_{TierColor}_xs.png`,
                        iconSize: [12, 12], // size of the icon
                        iconAnchor: [6, 6], // point of the icon which will correspond to marker's location
                        labelAnchor: [6, 0]
                    },
                    riseOnHover: true
                }
            }, {
                value: 'triangle',
                style: {
                    icon: {
                        fields: ['TierColor'],
                        iconUrl: `${environment.get('IMAGES_HOST')}/pin_triangle_{TierColor}_xs.png`,
                        iconSize: [12, 11], // size of the icon
                        iconAnchor: [6, 6], // point of the icon which will correspond to marker's location
                        labelAnchor: [6, 0]
                    },
                    riseOnHover: true
                }
            }, {
                value: 'pi',
                style: {
                    icon: {
                        fields: ['TierColor'],
                        iconUrl: `${environment.get('IMAGES_HOST')}/pin_pi_{TierColor}_xs.png`,
                        iconSize: [26, 26], // size of the icon
                        iconAnchor: [13, 13], // point of the icon which will correspond to marker's location
                        labelAnchor: [6, 0]
                    },
                    riseOnHover: true
                }
            }, {
                value: 'pi_2',
                style: {
                    icon: {
                        fields: ['TierColor'],
                        iconUrl: `${environment.get('IMAGES_HOST')}/pin_pi_2_{TierColor}_xs.png`,
                        iconSize: [26, 26], // size of the icon
                        iconAnchor: [13, 13], // point of the icon which will correspond to marker's location
                        labelAnchor: [6, 0]
                    },
                    riseOnHover: true
                }
            }];
            break;
        }

        if (!_.some(symbology.values, v => v.value === NETWORK_ICON)) {
            symbology.values.push(getNetworkSymbology());
        }

        this.getLayer().setOptions({ symbology });
        if (this.check() && this.getLayer().visible()) {
            return this.getLayer().reload();
        }
    }
}

export default GreenfieldControl;



// WEBPACK FOOTER //
// ./src/scripts/controls/GreenfieldControl.js